import React from "react";
import { useTheme } from "@mui/material/styles";

export default ({ color }) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.dark;
  }

  return (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 152.4 130.02"
      xmlSpace="preserve"
    >
      <rect x="26.57" y="26.04" fill="none" width="99.99" height="77.22" />
      <g>
        <path
          fill={color}
          d="M125.34,32.54c-0.67,0-1.22,0.55-1.22,1.22v67.06H83.94c4.45-0.81,10.09-1.14,15.61-1.46
		c0.01,0,0.02,0.01,0.04,0.01l0.01-0.01c0.13,0,0.26-0.02,0.38-0.06c0.89-0.3,1.69-0.83,2.33-1.52c8.61-5.94,12.73-9.78,15.73-17.79
		c1.43-1.87,2.15-4.18,2.02-6.54V27.28c0-0.18-0.02-0.35-0.1-0.53c-0.25-0.57-0.89-0.83-1.47-0.65c-0.04,0.01-0.09,0.01-0.13,0.03
		c0,0,0,0,0,0c-3.81,1.64-11.45,2.08-18.83,2.51c-8.97,0.52-18.22,1.06-22.95,3.7c-4.73-2.64-13.98-3.18-22.96-3.7
		c-7.38-0.43-15.02-0.87-18.83-2.51c0,0,0,0,0,0c-0.1-0.04-0.22-0.06-0.34-0.07c-0.05-0.01-0.09-0.03-0.14-0.03c0,0,0,0,0,0
		c-0.04,0-0.08,0.02-0.12,0.02c-0.12,0.01-0.24,0.03-0.34,0.07c-0.07,0.03-0.13,0.08-0.19,0.12c-0.07,0.04-0.14,0.08-0.2,0.14
		c-0.07,0.07-0.12,0.17-0.18,0.26c-0.03,0.05-0.07,0.08-0.09,0.13c0,0,0,0,0,0c-0.01,0.02-0.01,0.04-0.01,0.06
		c-0.05,0.14-0.08,0.28-0.08,0.41v68.28c0,0.49,0.29,0.93,0.74,1.12c4.21,1.81,11.71,2.24,19.65,2.7
		c5.55,0.32,11.21,0.66,15.68,1.46H29.01V33.76c0-0.67-0.55-1.22-1.22-1.22s-1.22,0.55-1.22,1.22v68.28c0,0.67,0.55,1.22,1.22,1.22
		h48.77c0,0,0,0,0,0v0h48.77l0,0c0.67,0,1.22-0.55,1.22-1.22V33.76C126.56,33.09,126.01,32.54,125.34,32.54z M104.54,93.19
		c0.86-3.38,0.89-7.48,0.88-10.69c2.06,0.48,5.71,1.02,8.88-0.02C112.19,86.68,109.36,89.6,104.54,93.19z M99.66,31.08
		c6.97-0.4,13.59-0.79,17.96-2.09v44.47c0.12,1.82-0.42,3.62-1.52,5.08c-0.03,0.03-0.05,0.06-0.07,0.09
		c-3.38,3.75-11.36,1.16-11.43,1.13c-0.12-0.04-0.25-0.06-0.38-0.06c-0.67,0-1.22,0.55-1.22,1.22v1.04
		c0.02,4.24,0.04,11.35-2.39,14.1c0,0,0,0,0,0c-0.34,0.4-0.78,0.7-1.27,0.89c-8.19,0.47-16.59,0.98-21.54,3.1V34.46
		C81.98,32.11,90.96,31.58,99.66,31.08z M35.51,94.71V28.99c4.36,1.31,10.99,1.69,17.95,2.09c8.7,0.51,17.68,1.03,21.88,3.38v65.57
		c-4.99-2.13-13.48-2.63-21.74-3.11C46.67,96.53,39.51,96.11,35.51,94.71z"
        />
        <path
          fill={color}
          d="M70.3,72.56c-5.55-0.91-11.16-1.46-16.78-1.65c-4.58-0.27-8.9-0.52-12.56-1.03c-0.67-0.09-1.28,0.37-1.38,1.04
		c-0.09,0.67,0.37,1.28,1.04,1.38c3.75,0.52,8.12,0.78,12.75,1.04c5.51,0.19,11,0.73,16.44,1.61c0.08,0.02,0.16,0.02,0.24,0.02l0,0
		c0.58,0,1.09-0.41,1.2-0.98C71.39,73.33,70.96,72.69,70.3,72.56z"
        />
        <path
          fill={color}
          d="M70.3,80.69c-5.55-0.91-11.16-1.46-16.78-1.65c-4.58-0.27-8.9-0.52-12.56-1.03c-0.02,0-0.04-0.01-0.05-0.01
		c-0.67-0.08-1.28,0.4-1.35,1.07c-0.08,0.67,0.4,1.28,1.07,1.35c3.75,0.52,8.12,0.78,12.75,1.04c5.51,0.19,11,0.73,16.44,1.61
		c0.08,0.02,0.16,0.02,0.24,0.02l0,0c0.58,0,1.09-0.41,1.2-0.98C71.39,81.46,70.96,80.82,70.3,80.69z"
        />
        <path
          fill={color}
          d="M70.3,88.82c-5.55-0.91-11.16-1.46-16.78-1.65c-4.58-0.27-8.9-0.52-12.56-1.03c-0.02,0-0.04-0.01-0.05-0.01
		c-0.67-0.08-1.28,0.4-1.35,1.07c-0.08,0.67,0.4,1.28,1.07,1.35c3.75,0.52,8.12,0.78,12.75,1.04c5.51,0.19,11,0.73,16.44,1.61
		c0.08,0.02,0.16,0.02,0.24,0.02l0,0c0.58,0,1.09-0.41,1.2-0.98C71.39,89.59,70.96,88.95,70.3,88.82z"
        />
        <path
          fill={color}
          d="M70.3,38.42c-5.55-0.91-11.16-1.46-16.78-1.65c-4.58-0.27-8.9-0.52-12.56-1.02c-0.35-0.05-0.7,0.05-0.97,0.29
		c-0.27,0.23-0.42,0.57-0.42,0.92v24.38c0,0.61,0.45,1.12,1.05,1.21c3.75,0.52,8.12,0.78,12.75,1.04c5.51,0.19,11,0.73,16.44,1.61
		c0.08,0.02,0.16,0.02,0.24,0.02v0.01c0.67,0,1.22-0.55,1.22-1.22V39.62C71.28,39.04,70.87,38.53,70.3,38.42z M68.84,62.54
		c-5.08-0.72-10.19-1.18-15.32-1.39c-4.15-0.24-8.08-0.47-11.51-0.89l0-21.94c3.43,0.4,7.3,0.63,11.36,0.87
		c5.18,0.2,10.34,0.67,15.46,1.43V62.54z"
        />
        <path
          fill={color}
          d="M83.07,91.23L83.07,91.23c0.08-0.01,0.16-0.02,0.24-0.03c4.93-0.82,9.9-1.33,14.89-1.52
		c0.67-0.04,1.19-0.62,1.15-1.29c-0.06-0.66-0.62-1.16-1.29-1.15c-4.61,0.2-9.2,0.64-13.76,1.3V73.13
		c5.12-0.75,10.29-1.23,15.46-1.43c4.07-0.24,7.94-0.47,11.36-0.87v4.35c0,0.67,0.55,1.22,1.22,1.22c0.67,0,1.22-0.55,1.22-1.22
		v-5.74c0-0.06,0-0.11-0.01-0.17c-0.09-0.67-0.71-1.13-1.38-1.04c-3.66,0.51-7.98,0.76-12.56,1.02c-5.62,0.19-11.23,0.74-16.78,1.65
		c-0.57,0.11-0.98,0.62-0.98,1.2v17.88C81.85,90.69,82.39,91.23,83.07,91.23z"
        />
        <path
          fill={color}
          d="M82.29,64.94c0.28,0.23,0.65,0.32,1.01,0.25c5.44-0.88,10.93-1.42,16.44-1.61c4.63-0.27,9-0.52,12.75-1.04
		c0.6-0.08,1.05-0.6,1.05-1.21V36.94c0-0.35-0.15-0.69-0.42-0.92c-0.26-0.23-0.62-0.34-0.97-0.29c-3.66,0.51-7.98,0.76-12.56,1.02
		c-5.62,0.19-11.23,0.74-16.78,1.65c-0.57,0.11-0.98,0.62-0.98,1.2V64C81.85,64.36,82.01,64.71,82.29,64.94L82.29,64.94z
		 M84.28,40.62c5.12-0.75,10.29-1.23,15.46-1.43c4.07-0.24,7.94-0.47,11.36-0.87l0.01,21.93c-3.42,0.42-7.36,0.65-11.51,0.89
		c-5.13,0.2-10.24,0.67-15.33,1.39V40.62z"
        />
      </g>
    </svg>
  );
};
